export const SEARCH_FMCSA_COMPANY_BY_NAME = gql`
  query SEARCH_FMCSA_COMPANY_BY_NAME($name: String!, $pageInfo: PageInfoInput) {
    searchResults: searchFMCSACompanyByName(name: $name, pageInfo: $pageInfo) {
      lastPage
      normalizedQuery
      dotLookup
      pageInfo {
        offset
        limit
      }
      companies {
        dotNumber
        companyName
        alternativeCarrierName
        phone
        statusCode
        allowedToOperate
        powerUnits
        inDirectory
        address {
          street
          city
          state
          country
          zipCode
        }
      }
    }
  }
`

export const SEARCH_FMCSA_COMPANY_BY_DOT_NUMBER = gql`
  query SEARCH_FMCSA_COMPANY_BY_DOT_NUMBER($dotNumber: String!) {
    searchResult: searchFMCSACompanyByDOTNumber(dotNumber: $dotNumber) {
      company {
        dotNumber
        companyName
        alternativeCarrierName
        phone
        statusCode
        allowedToOperate
        powerUnits
        inDirectory
        address {
          street
          city
          state
          country
          zipCode
        }
      }
    }
  }
`
